import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchWrapper } from "../_helpers";
import { fCurrency } from "../utils/formatNumber";

// Common empty Product

const defaultLocation = [{ProductLocationID:0, Aisle: "",Level: "",Bay: "",IsDeleted:false}]


const emptyProductTadData = {
  ProductID: 0,
  WCProductID: 0,
  PDWCProductID: 0,
  WarehouseID: 0,
  WarehouseOption: null,
  CategoryID: 0,
  IsGemar: false,
  IsPartyDeco: false,
  CategoryOption: null,
  SubCategoryID: 0,
  SubCategoryOption: null,
  ProductName: "",
  Description: "",
  ShortDescription: "",
  Cost: "",
  RegularPrice: "",
  Aisle: "",
  Level: "",
  Bay: "",
  GPARTNERPrice: "",
  GStarPrice: "",
  PFAPrice: "",
  GVendorPrice: "",
  GAssociatePrice: "",
  ProductImages: [],
  PerBoxCount: "",
  IsDisableDiscount: false,
  Weight: "",
  DimensionLength: "",
  DimensionWidth: "",
  DimensionHeight: "",
  ShippingMethodID: 0,
  ShippingMethodOption: null,
  IsManageStock: false,
  StockQuantity: 0,
  AllowBackOrder: 0,
  AllowbackordersOption: null,
  QuotaTrigger1: "",
  QuotaTrigger2: "",
  LowStockThreshold: "",
  HighStockThreshold: "",
  SKU: "",
  StockStatusID: 0,
  VendorID: 0,
  Manufacturer: "",
  VendorOption: null,
  StockstatusOption: null,
  TypeProductImageModelList: [],
  TypeProductAttributeModelList: [],
  TypeProductTermModelList: [],
  AttributeOption: null,
  AttributeID: 0,
  PackageTypeOption: null,
  PackageTypeID: 0,
  ProductAttributeModelList: [],
  ProductTermModelList: [],
  setSubmitted: false,
  CreatedBy: 0,
  Status: 1,
  WCUserRoleIgnoreDiscountID: 0,
  WCUserRolePricesID: 0,
  WCCOGCostID: 0,
  PDWCUserRoleIgnoreDiscountID: 0,
  PDWCUserRolePricesID: 0,
  PDWCCOGCostID: 0,
  PartyDecoPrice: "",
  WarrantyPeriod:"",
  TypeLocationList: defaultLocation,
  MinimumQuantity: "",
};

// create slice
const name = "product";
const initialState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();
const extraReducers = createExtraReducers();
const slice = createSlice({ name, initialState, reducers, extraReducers });

// exports

export const productActions = { ...slice.actions, ...extraActions };
export const productReducer = slice.reducer;

// implementation

function createInitialState() {
  return {
    productTabList: emptyProductTadData,
    activeProductTab: "General",
    pa_attributesTabData: {},
    productResponse: [],
    productList: [],
    archivedProductList: [],
    isLoading: false,
    product: {},
    deleteProductResponse: [],
    previousProductTabList:{}
  };
}
function createReducers() {
  return {
    tempSetProductTabData,
    clearProductData,
    clearProductResponse,
    tempActiveProductTab,
  };

  function clearProductResponse(state, action) {
    state.productResponse = [];
  }

  function clearProductData(state, action) {
    state.productResponse = [];
    state.productTabList = emptyProductTadData;
    state.previousProductTabList={};
    state.activeProductTab = "General";
  }

  function tempSetProductTabData(state, action) {
    state.productTabList = action.payload && action.payload;
  }

  function tempActiveProductTab(state, action) {
    state.activeProductTab = action.payload && action.payload;
  }
}

function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_API_URL}/Product`;

  return {
    GetProductDetailsByID: GetProductDetailsByID(),
    saveProduct: saveProduct(),
    getProductAll: getProductAll(),
    deleteProduct: deleteProduct(),
    archivedProduct: getArchivedProduct(),
    handleArchive: handleArchive(),
  };
  function GetProductDetailsByID() {
    return createAsyncThunk(
      `${name}/GetProductDetailsByID`,
      async (detail) =>
        await fetchWrapper.get(
          `${baseUrl}/GetProductDetailsByID?ProductID=` + detail.ProductID
        )
    );
  }

  function saveProduct() {
    return createAsyncThunk(
      `${name}/saveProduct`,
      async (addFormData) =>
        await fetchWrapper.post(`${baseUrl}/InsertUpdateProduct`, addFormData)
    );
  }
  function getProductAll() {
    return createAsyncThunk(
      `${name}/getProductAll`,
      async (addFormData) =>
        await fetchWrapper.post(`${baseUrl}/GetProductDetails`, addFormData)
    );
  }
  function deleteProduct() {
    return createAsyncThunk(
      `${name}/deleteProduct`,
      async (detail) =>
        await fetchWrapper.post(
          `${baseUrl}/DeleteProduct?ProductID=${detail.ProductID}&DeletedBy=${detail.DeletedBy}`
        )
    );
  }
  function getArchivedProduct() {
    return createAsyncThunk(
      `${name}/getArchivedProduct`,
      async () => await fetchWrapper.get(`${baseUrl}/GetArchivedProductList`)
    );
  }
  function handleArchive() {
    return createAsyncThunk(`${name}/HandleArchive`, async (data) => {
      await fetchWrapper.post(
        `${baseUrl}/HandleArchive?ProductID=${data?.productID}&ArchiveStatus=${data?.status}`
      );
    });
  }
}

function createExtraReducers() {
  return {
    ...GetProductDetailsByID(),
    ...saveProduct(),
    ...getProductAll(),
    ...deleteProduct(),
    ...getArchivedProduct(),
  };

  function GetProductDetailsByID() {
    var { pending, fulfilled, rejected } = extraActions.GetProductDetailsByID;
    return {
      [pending]: (state) => {
        state.productTabList = { loading: true };
      },
      [fulfilled]: (state, action) => {
        let stateProductTabList = { ...state.productTabList };

        let productTabRow = { ...action.payload };
        productTabRow.Cost = fCurrency(productTabRow.Cost);
        productTabRow.RegularPrice = fCurrency(productTabRow.RegularPrice);
        productTabRow.GPARTNERPrice = fCurrency(productTabRow.GPARTNERPrice);
        productTabRow.GStarPrice = fCurrency(productTabRow.GStarPrice);
        productTabRow.PFAPrice = fCurrency(productTabRow.PFAPrice);
        productTabRow.GVendorPrice = fCurrency(productTabRow.GVendorPrice);
        productTabRow.GAssociatePrice = fCurrency(
          productTabRow.GAssociatePrice
        );
        productTabRow.PartyDecoPrice = fCurrency(productTabRow.PartyDecoPrice);

        productTabRow.WarehouseOption = {
          value: productTabRow.WareHouseID,
          label: productTabRow.WareHouseNumber,
        };
        productTabRow.CategoryOption = {
          value: productTabRow.CategoryID,
          label: productTabRow.CategoryName,
        };
        productTabRow.SubCategoryOption = {
          value: productTabRow.SubCategoryID,
          label: productTabRow.SubCategoryName,
        };
        productTabRow.ShippingMethodOption = {
          value: productTabRow.ShippingMethodID,
          label: productTabRow.ShippingMethod,
        };

        productTabRow.PackageTypeOption = {
          value: productTabRow.PackageTypeID,
          label: productTabRow.PackageType,
        };
        productTabRow.VendorOption = {
          value: productTabRow.VendorID,
          label: productTabRow.VendorName,
        };
        productTabRow.StockstatusOption = {
          value: productTabRow.StockStatusID,
          label: productTabRow.StockStatus,
        };
        let AllowBackOrderLable =
          productTabRow.AllowBackOrder === 1
            ? "Do not allow"
            : productTabRow.AllowBackOrder === 2
            ? "Allow, but notify Customer"
            : productTabRow.AllowBackOrder === 3
            ? "Allow"
            : "";
        if (AllowBackOrderLable) {
          productTabRow.AllowbackordersOption = {
            value: productTabRow.AllowBackOrder,
            label: AllowBackOrderLable,
          };
        } else {
          productTabRow.AllowbackordersOption = {};
        }
        productTabRow.AttributeOption = null;
        let ImageList = [...productTabRow.ProductImageModelList];
        stateProductTabList = {
          ...productTabRow,
          TypeProductImageModelList: [...ImageList],
          TypeLocationList:[...productTabRow.TypeProductLocationList]
        };
        let termList = [...productTabRow.ProductTermModelList];

        stateProductTabList &&
          stateProductTabList.ProductAttributeModelList.map((val, index) => {
            let termFilterList = termList.filter(
              (d) =>
                d.AttributeID === val.AttributeID &&
                d.ProductAttributeIndex === val.IndexID
            );
            let termOptions = [];
            termFilterList.map((termVal) => {
              termOptions.push({
                value: termVal.TermID,
                label: termVal.TermName,
              });
            });

            stateProductTabList.ProductAttributeModelList[
              index
            ].ProductTermOptionList = [...termOptions];
          });

        state.productTabList = stateProductTabList;
        state.previousProductTabList = stateProductTabList;
      },
      [rejected]: (state, action) => {
        state.productTabList = { error: action.error };
        state.previousProductTabList={}
      },
    };
  }

  function saveProduct() {
    var { pending, fulfilled, rejected } = extraActions.saveProduct;
    var start;
    return {
      [pending]: (state) => {
        start = performance.now();
        state.productResponse = { loading: true };
      },
      [fulfilled]: (state, action) => {
        state.productResponse = action.payload;
        var end = performance.now();
        console.log("Local API : " + Math.floor(end - start) / 1000);
      },
      [rejected]: (state, action) => {
        state.productResponse = { error: action.error };
      },
    };
  }
  function getProductAll() {
    var { pending, fulfilled, rejected } = extraActions.getProductAll;
    return {
      [pending]: (state) => {
        state.isLoading = false;
        state.productResponse = { loading: true };
      },
      [fulfilled]: (state, action) => {
        state.isLoading = true;
        state.productList = action.payload;

        state.productResponse = [];
        state.deleteProductResponse = [];
        state.activeProductTab = "General";
      },
      [rejected]: (state, action) => {
        state.isLoading = true;
        state.productResponse = { error: action.error };
        // state.error = { error: action.error };
      },
    };
  }
  function deleteProduct() {
    var { pending, fulfilled, rejected } = extraActions.deleteProduct;
    return {
      [pending]: (state) => {
        state.subCategoryResponse = { loading: true };
      },
      [fulfilled]: (state, action) => {
        state.deleteProductResponse = action.payload;
        state.productResponse = [];
      },
      [rejected]: (state, action) => {
        state.deleteProductResponse = { error: action.error };
      },
    };
  }

  function getArchivedProduct() {
    var { pending, fulfilled, rejected } = extraActions.archivedProduct;
    return {
      [pending]: (state) => {
        state.isLoading = false;
        state.subCategoryResponse = { loading: true };
      },
      [fulfilled]: (state, action) => {
        console.log("state", state);
        state.isLoading = true;
        state.archivedProductList = action.payload && action.payload;
      },
      [rejected]: (state, action) => {
        state.isLoading = true;
        state.deleteProductResponse = { error: action.error };
      },
    };
  }
}
